import { render, staticRenderFns } from "./chart-add-info.vue?vue&type=template&id=40b33691&scoped=true&"
import script from "./chart-add-info.vue?vue&type=script&lang=ts&"
export * from "./chart-add-info.vue?vue&type=script&lang=ts&"
import style0 from "./chart-add-info.vue?vue&type=style&index=0&id=40b33691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b33691",
  null
  
)

export default component.exports